// Label economy for the canvas (design manual §7.4). Nodes are sized to their
// label, so an unbounded label is an unbounded node; and past a certain count
// the labels stop being readable at any zoom that shows the whole graph.

/** Longest label drawn on a node. The full text stays in node data. */
export const LABEL_MAX_CHARS = 60;

/** Below this zoom the labels are smaller than the strokes that draw them. */
export const COMPACT_ZOOM = 0.35;

/** Node count above which labels are withdrawn unless the user raises the limit. */
export const DEFAULT_LABEL_NODE_LIMIT = 150;

export function truncateLabel(label: string, max = LABEL_MAX_CHARS): string {
  if (label.length <= max) return label;
  return `${label.slice(0, max - 1).trimEnd()}…`;
}

/**
 * Whether nodes should draw as bare boxes. `limit` of 0 means "never withdraw
 * labels for count"; the zoom floor always applies.
 */
export function compactLabels(nodeCount: number, zoom: number, limit: number): boolean {
  if (zoom < COMPACT_ZOOM) return true;
  return limit > 0 && nodeCount > limit;
}
